// Greensock
// register the plugin:
// Greensock
// register the plugin:

gsap.config({ nullTargetWarn: false });

gsap.registerPlugin(ScrollTrigger);

const item = document.querySelectorAll(".large-image-animation");

item.forEach(addTimeline);

function addTimeline(project, index) {

  const color = project.querySelector(".animation-color");
  const imagecolor = project.querySelector(".animated-image");
  const imagecolortwo = project.querySelector(".second-animated-image");
  const text = project.querySelector(".animated-image-content");
  const color_two = project.querySelector(".second-ac");
  const text_two = project.querySelector(".second-aic");
  
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: project,
      pin: false,
      start: "-=200",
      scrub: 1,
      //ease: "power1.inOut",
      //toggleActions: "play none none reverse",
      end: "+=200"
    }
  })
  
  .add("start")
  .from(color, {
    autoAlpha: 0,
    ease: "power3",
    duration: 0.1
  }, "start")
  .from(text, {
   autoAlpha: 0,
   scale: 0.7,
   ease: "power3",
   duration: 0.1
  }, "start")
  .from(color_two, {
    autoAlpha: 0,
    ease: "power3",
    duration: 0.1
  }, "start")
  .from(text_two, {
    autoAlpha: 0,
    scale: 0.7,
    ease: "power3",
    duration: 0.1
  }, "start")
  .to(imagecolortwo,{
    '-webkit-filter':'grayscale(100%)',
    filter: 'grayscale(100%)',
    ease: "power3",
    duration: 0.1
  }, "start")
  .to(imagecolor, {
    '-webkit-filter':'grayscale(100%)',
    filter: 'grayscale(100%)',
    ease: "power3",
    duration: 0.1
  }, "start");
}

// jQuery(function($){

//   $(document).ready(function() {
//     var maxHeight = -1;

//     $('.title-image>.title').each(function() {
//       maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
//     });

//     $('.title-image>.title').each(function() {
//       $(this).height(maxHeight);
//     });
//     console.log(maxHeight);
//   });

// });
